import * as React from 'react'
import Link from '../../helper/link'

interface Props {
    message?: {
        args: {
            ct: number
        }
    }
}

export default class SessionStartRepeat extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        if (!message) {
            return (
                <p>
                    We observed Traces that start the session more than once, indicating a bug that likely causes a performance degradation.
                </p>
            )
        }

        const { args } = message

        return (
            <div>
                <p>
                    The session is started in this trace <strong>{args.ct}</strong> times, indicating a bug that likely causes a performance
                    degradation.
                </p>

                <p>
                    <Link route="XhprofProfilerBundle.Profile.callgraph" query={{ fn: 'session_start' }}>
                        View session_start() in Call Graph
                    </Link>
                </p>
            </div>
        )
    }
}
